<template>
  <div class="fwvid" :class="{inpage: inpage}">
    <div class="max-holder" :class="{inpage: inpage}" v-if="isVideo" :style="{width: mwidth, height: mheight}">
      <div class="zax-holder" :class="{loaded: loaded}">
        <video-player :url="url"  v-on:load="setSize" :autoplay="autoplay" :muted="muted" :style="{width: mwidth, height: mheight}"  />
      </div>
    </div>
    <gif-player  :url="url" v-if="isGif" />
    <div class="yt-holder" v-if="isYoutube" :class="{inpage: inpage}">
      <you-tube-player :url="external_url" :muted="muted" :autoplay="autoplay" />
    </div>
    <div class="yt-holder" v-if="isVimeo" :class="{inpage: inpage}">
      <vimeo-player :url="external_url" :muted="muted" :autoplay="autoplay" :inpage="inpage" />
    </div>
    <router-link v-if="inpage" class="permalink" :to="permalink" title="permalink"></router-link>
  </div>
</template>

<script>
import VideoPlayer from '@/components/video/VideoPlayer.vue'
import GifPlayer from '@/components/video/GifPlayer.vue'
import YouTubePlayer from '@/components/video/YouTubePlayer.vue'
import VimeoPlayer from '@/components/video/VimeoPlayer.vue'

const orgw = 'auto'
const orgh = 'auto'

export default {
  components: {
    VideoPlayer,
    GifPlayer,
    YouTubePlayer,
    VimeoPlayer
  },
  props: {
    image: {},
    artist: {},
    inpage: Boolean,
    muted: Boolean,
    autoplay: Boolean
  },
  
  computed: {
    isVideo () {
      return ((!this.external_url) && ((this.ext === 'mp4') || (this.ext === 'm4v') || (this.ext === 'mov') || (this.ext === 'flv')))
    },
    isGif () {
      return (this.ext === 'gif')
    },
    isYoutube (){
      if(!this.external_url) return false
      return (this.ext === 'ytv') && (this.external_url.indexOf('vimeo') < 0)
    },
    isVimeo () {
      if(!this.external_url) return false
      return (this.external_url.indexOf('vimeo') > 0)
    },
    permalink: function () {
      if(this.image.url && this.artist) {
        return this.$k.getImagePermalink(this.image, this.artist)
      }
      return ''
    }
  },
  data () {
    return {
      ext: '',
      url: '',
      mwidth: orgw,
      mheight: orgh,
      loaded: false,
      external_url: '',
      poster: ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData: async function (){
      
      if(this.image) {
        let ext = this.image.swf.split('.').pop().toLowerCase()
        if((ext === 'mov')||(ext === 'flv')){
          this.url = `media/artist/${this.artist.portfolio_url}/${this.image.swf}.mp4`
        }
        else {
          this.url = `media/artist/${this.artist.portfolio_url}/${this.image.swf}`
        }
        this.ext = ext
        this.external_url = this.image.video_url
        this.poster = this.$k.getZoomImage(this.image.url)
        
        
      }
      else {
        this.external_url = ''
      }
      
    },
    setSize(sz) {
      let mx = this.$el.offsetWidth
      let factor = mx / sz.width
      this.mwidth = (factor * sz.width) + 'px'
      this.mheight = (factor * sz.height) + 'px'
      this.loaded = true;
    }
  },
  watch: {
    image () {
      if(this.image) {
        if(this.image.swf){
          if(this.artist.portfolio_url)
          {
            this.loaded = false
            this.loadData()
          }
        }
      }
      
    },
    artist () {
      if(this.artist) {
        if(this.artist.portfolio_url) {
          this.loaded = false
          this.loadData()
        }
      }
    }
    
  }
}
</script>
<style scoped>
.max-holder{
  max-width:60vw;
  max-height:calc(98vh - 80px);
  display:block;
}

.max-holder.inpage{
  max-width:100%;
  width:100%;
  max-height:none;
  height:auto;
}

.zax-holder{
  width:60vw;
  height:calc(98vh - 80px);
  opacity:0;
  display:block;
  transition:all 0.15s linear;
}

.inpage .zax-holder{
  width:100%;
  height:auto;
}

.zax-holder.loaded{
  opacity:1;
}

.yt-holder{
  width:60vw;
  height:33.75vw;
}

.yt-holder.inpage{
  width:100%;
  height:auto;
}

.fwvid{
  width:75%;
  position:relative;
  background-color:#eeeeee;
}

.fwvid.inpage{
  width:100%;
}


</style>


